export const CourseHome = {
    "考勤":"Attence",
    "表现":"Performance",
    "成绩管理":"Grade",
    "学情分析":"Analysis",
    "报名审核":"Enroll",
    "成绩":"Grade",
    "学习分析":"Analysis",
    "错题集":"Mistakes",
    "课堂正在上课":"The class is in class/live...",
    "立即进入":"Enter now",
    "正在会议中":"In conference...",
    "个会议正在进行中":"meetings in progress…",
    "会议功能需要绑定邮箱后才能使用!":"会议功能需要绑定邮箱后才能使用!",
    "学习资料":"Materials",
    "慕课资料":"Mooc",
    "录屏录像":"Recorded video",
    "直播录像":"Live video",
    "课程内容":"Content",
    "加课码已停用":"Join code disabled",
    "加课码已启用":"Join code enabled",
    "学生视角":"Viewer",
    "课堂评价":"Evaluation",
    "分组":"Group",
    "加课码":"Join Code ",
    "已认证":"Certified",
    "成员":"Member",
    "已加课":"join ",
    "课程介绍":"Intro",
    "个章节":" Chapters",
    "个活动":" Activities",
    "该小节暂无内容":"No content in this section",
    "该课程暂无章节":"No chapter in this course",
    "正同步数据":"Synchronizing data",
    "检测到旧版课程数据向新版同步未完成":"It is detected that the old version of course data has not been synchronized to the new version",
    "当前同步进度":"Current progress",
    "学习进度":"learning progress",
    "继续学习":"Continue study",
    "当前进入学生视角":"Enter the perspective of students and experience the course as students",
    "进行中":"Ongoing...",
    "最新":"newest",
    "目录":"Catalogue",
    "待完成":"Todo ",
    "学时":" Class hours",
    "请完善以下信息":" 请完善以下信息",
    "班级":"Class",
    "请输入班级":"Please enter your class",
    "年级":"Grade",
    "请选择年级":"Please select your grade",
    "入学时间":"Time of admission",
    "请选择入学时间":"Please select the time of admission",
    "引用":"Quote",
    "课堂已结束请对本次课堂进行评价":"课堂已结束！请对本次课堂进行评价（匿名）",
    "匿名提交评价":"Submit comments anonymously",
    "评价成功":"Evaluate successfully!",
    "被引用":"Quoted",
    "次":"times",
    "已下载":"Downloaded",
    "引用到课程":"Reference to course",
    "慕课外链":"Mooc links",
    "邀请您进入课程":"invite you to the course",
    "输入加课码直达":"Enter the course code to join",
    "评审":"Review",
    "截止":"Deadline:",
    "起止":"Start and end:",
    "试题":"Test questions:",
    "直播视频":"Live video",
    "录播视频":"Recording video",
    "互动视频":"Interactive video",
    "待学习":"To be learned",
    "待参与":"To be involved",
    "未提交":"Not submitted",
    "已提交":"Submitted",
    "已批改":"Corrected",
    "待批改":"To be corrected",
    "进入会议":"Enter the meeting",
    "待开始":"To be started",
    "发布会议":"Release meeting",
    "将于开始":"Will start at",
    "空开始":"",
    "未批":"Uncorrected",
    "已学完":"Learned",
    "创建时间":"Creation time:",
    "抢答":"Rush to answer",
    "抢答成功":"Successful reply",
    "已有":"",
    "学年学期":"School year-Semester",
    "授课地点":"Location",
    "授课模式":"Teaching mode",
    "全年":"Full school year",
    "上学期":"The first half of the semester",
    "下学期":"The second half of the semester",
    "请确认是否删除此":"Please confirm whether to delete this",
    "当前显示的教学活动模块":"Teaching activity module currently displayed",
    "原":"(",
    "更多模块":"More modules",
    "点击即可添加模块":"Click to add a module",
    "修改教学活动模块名":"Modify the module name",
    "结构化组织教学活动":"Structured organization of teaching activities",
    "上课课件":"Courseware",
    "老师分享资料":"Teacher share material",
    "投票问卷答题":"Votes, questions",
    "报告或文档型作业":"Report or document type homework",
    "提供师生讨论功能":"Provide discussion function",
    "阶段性测试考核":"Periodic test and assessment",
    "通知公告等":"Notice, announcement, etc",
    "链接腾讯会议":"Link Tencent Conference",
    "教学活动模块名称不能为空":"The name of teaching activity module cannot be empty",
    "教学活动模块名称最多 8 个字":"The name of the teaching activity module can be up to 8 characters",
    "至少存在一个教学活动模块":"At least one teaching activity module",
    "当前暂无可学习内容":"There is currently no content to learn",
    "老师已经禁止学生发起话题":"The teacher has forbidden students to initiate topics",
    "您有未完成的评教":"You have unfinished teaching evaluation",
    "是否填写评教":"Whether to fill in teaching evaluation",
    "去填写":"Fill in",
    "暂不填写":"Not filled in",
    "开始评教":"Begin teaching evaluation",
    "题未作答请检查后提交":"question not answered, please check before submiting",
    "评教提交成功":"Successfully submitted the evaluation",
    "今日":"Today",
    "学生评价参与率":"Student evaluation participation rate",
    "好评率":"Praise rate",
    "待改进":"To be improved",
    "得分占比":"Percentage of scores",
    "问题评价占比":"Proportion of problem evaluation",
    "自定义日期":"Custom date",
    "请输入":"Please enter",
    "提交成功等待审核":"Submitted successfully, waiting for approval",
    "耐心等待老师审核如有疑问请与课程老师联络":"Wait patiently for the teacher's review. If you have any questions, please contact the course teacher",
    "有必填项未填":"Required items are not filled",
    "未认证":"Not certified",
    "重命名标签":"Rename label",
    "全选":"Select All",
    "移出小组":"Remove",
    "加入小组":"Join",
    "设为组长":"Set as team leader",
    "设为组长跳转":"Set as group leader jump",
    "组数":"Number of groups",
    "允许学生选组":"Allow students to select group",
    "禁止":"Prohibit",
    "允许":"Allow",
    "学生进组":"students join the group",
    "未分组学生":"Ungrouped students",
    "我加入的小组":"The group I joined",
    "人数":"Number of members",
    "其他组":"Other groups",
    "本分组内暂无小组":"There is no group in this group",
    "你可以":"You can",
    "建立第一个小组":"set up the first group",
    "新建小组":"New group",
    "分组设置":"Group settings",
    "已删除":"Deleted",
    "设置成功":"Setting succeeded",
    "设定组长":"Set team leader",
    "设定组长成功":"Successfully set the team leader",
    "分组标题":"Group title",
    "请输入分组标题":"Please enter the group title",
    "小组人数上限":"Maximum number of group members",
    "允许学生新建删除小组":"Allow students to create/delete groups",
    "组数上限":"Maximum number of groups",
    "移除成功":"Removal succeeded",
    "加入成功":"Joined successfully",
    "选择加入的小组":"Select a group to join",
    "添加成员":"Add members",
    "加入该组":"Join this group",
    "退出该组":"Exit this group",
    "移除组员":"Remove members",
    "编辑小组":"Edit group",
    "删除小组":"Delete group",
    "确定要删除小组":"Are you sure to delete the group",
    "已退出":"Exited",
    "已加入":"Joined",
    "移出成功":"Removal succeeded",
    "添加组员":"Add group members",
    "暂无分组":"No grouping",
    "固定组":"Fixed group",
    "自由组":"Free group",
    "限制组":"Limit group",
    "已进组人数":"Number of group members",
    "未进组人数":"Number of people not in the group",
    "新建分组":"Create group",
    "小组名称":"Group name",
    "请输入小组名称":"Please enter the group name",
    "加入时间":"Joining time",
    "学生信息":"Student information",
    "助教信息":"Assistant information",
    "老师信息":"Teacher information",
    "学生分组":"Student groups",
    "设置":"Settings",
    "不允许退课":"No quit allowed",
    "成员设置":"Member settings",
    "总览":"Overview",
    "松开发送":"Release and send",
    "按住讲话":"Press and hold to speak",
    "松开发送上滑取消":"Release sending, slide up  cancel",
    "取消发送语音":"Cancel sending voice",
    "老师已禁止发言":"The teacher has forbidden speaking!",
    "条":"in total",
    "按时间":"By time",
    "课堂对象全部成员":"Class objects: all members",
    "上课人数":"Number of students",
    "上课时长":"Length of class",
    "提问":"ask questions",
    "口头回答":"Oral answer",
    "手机抢答":"Mobile phone rush answer",
    "查看详情":"View details",
    "关闭弹幕":"Close the bullet screen",
    "弹幕数":"Number of bullets",
    "日":" ",
    "暂无课堂记录":"No class record",
    "话题参与率":'Topic participation rate',
    "互动参与率":"Interactive participation rate",
    "出勤率":"Attendance rate",
    "表现星星数":"Number of stars",
    "作业提交率":"Homework submission rate",
    "班级平均":"Class average",
    "学生个人":"Individual student",
    "发布数":"Publications",
    "回答数":"Answers",
    "学习人数":"Number of students",
    "标签":"label",
    "固定小组":"Fixed group",
    "活动分组":"Activity group",
    "整体完成率":"Overall completion rate",
    "作业提交":"homework submission",
    "资料学习":"Material learning",
    "测试提交":"Test submission",
    "本周":"This week",
    "本月":"This month",
    "课堂互动次数":"class interactions",
    "作业发布次数":"homework",
    "测试发布次数":"test",
    "话题回复数":"topic replies",
    "互动课件发布次数":"courseware",
    "资料发布次数":"material",
    "资料互动课件发布次数":" materials/ courseware",
    "弹幕条数":"bullet screens",
    "课堂互动":"Class interaction",
    "累计发布抢答条数":"Cumulative number of quick answers",
    "参与抢答人数":"Number of answers",
    "抢答平均参与率":"Average participation rate of answers",
    "累计发布提问次数":"Cumulative number of questions",
    "累计随机提问次数":"Cumulative number of random questions",
    "累计点名提问次数":"Cumulative number of roll call questions",
    "累计发布个数":"Cumulative number of releases",
    "答题总数":"Total number of answers",
    "平均参与率":"Average participation rate",
    "平均正确率":"Average accuracy",
    "互动答题榜":"Interactive answer list",
    "正确率":"Accuracy",
    "参与率":"Participation rate",
    "抢答榜":"Rush to answer list",
    "成功次数":"Success times",
    "表现榜":"Performance list",
    "累计星星数":"Cumulative number of stars",
    "累计发布次数":"Cumulative number of releases",
    "提交作业份数":"Number of submitted homework",
    "作业平均分":"Average score of homework",
    "作业提交人数":"Number of homework submitters",
    "准时提交率":"On time submission rate",
    "测试平均分":"Average test score",
    "累计参与测试人数":"Cumulative number of people tested",
    "测试提交率":"Test submission rate",
    "累计话题发布数":"Cumulative number of topics",
    "累计话题回复数":"Cumulative number of topic replies",
    "累计点赞数":"Cumulative likes",
    "话题精华率":"Topic essence rate",
    "成员参与率":"Member participation rate",
    "资料类型":"Material type",
    "资料互动课件":"Materials/interactive courseware",
    "平均学习进度":"Average learning progress",
    "整体分析":"Overall analysis",
    "学生分析":"Student analysis",
    "开始上课":"classes begin",
    "下课":"class is over",
    "创建人":"creator",
    "提交":"submit",
}
